// import design, { remCalc } from '@/config/design';
export default {
  styles: {}
};